<template>
    <div class="modal-mask" v-if="loaded">
        <div v-on:click.self="explainerStop" class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header" style="padding-bottom:0px;">
              <h2><i style="padding-right:5px;font-size:1.2em;position:relative;top:5px;left:2px;" class="bi bi-chat-square-text"></i> Explainer</h2>
              <button type="button" class="btn btn-link" @click.prevent="explainerStop" style="color:#666;position:relative;top:-7px;right:-10px;;font-size:1.3em;"><i class="bi bi-x-lg"></i></button>
            </div>

            <div v-if="explainerKey != null" class="modal-body explainer-body" v-bind:style="explainerStyle" v-html="contents">
              
            </div>

            <div v-if="explainerHtml != null" class="modal-body explainer-body" v-bind:style="explainerStyle" v-html="explainerHtml">
              
            </div>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */


export default {
    name: 'Explainer',
    data() {
      return {
        loaded: false,
        title: null,
        contents: null
      }
    },
    created() {
    },
    mounted() {
      this.$axios
         .get(process.env.VUE_APP_API+"/api/explainer/"+this.explainerKey, {}, { timeout:4 })
         .then(response => {
            this.title = response.data["title"]
            this.contents = response.data["content_html"]
            this.loaded = true;
         })
         .catch(error => {
            this.title = this.explainerKey
            this.contents = "<p>This explainer could not be found. <br/><br/>The explainer for key <code>"+this.explainerKey+"</code> was not found in our system. We are currently writing explainers for various topics, so they should become available shortly.</p>"
            this.loaded = true;
         })
    },
    computed: {
      explainerKey() {
        return this.$store.state.explainerModal['key'];
      },
      explainerHtml() {
        return this.$store.state.explainerModal['content'];
      },
      explainerModal() {
        return this.$store.state.explainerModal
      },
      explainerHeight() {
        return window.innerHeight - 200;
      },
      explainerStyle() {
        return "min-height:100px;max-height:"+this.explainerHeight+"px;overflow:scroll;"
      }
    },
    filters: {
    },
    methods: {
    },
};
</script>


<style>
div.explainer-body {
  border-top:1px solid #ddd;
  margin-top:4px;
  margin-bottom:5px;
  padding:5px 0px;

}
div.explainer-body ul {
  margin-top:5px;
  margin-bottom:8px;
}
div.explainer-body h1 {
  font-size:1.6em;
  padding:10px 10px 0px 10px;;
  font-weight:bold;
}
div.explainer-body h2 {
  font-size:1.2em;
  padding:5px 10px 0px 10px;;
  font-weight:bold;
}
</style>

<style scoped>


</style>
